import { Card, Flex, Tag } from 'antd';
import { EditButton, useTable } from '@refinedev/antd';
import { FileDoneOutlined } from '@ant-design/icons';
import { HttpError, useShow } from '@refinedev/core';
import { IAssignment, IAssignmentUser } from 'interfaces/assignments';
import {
  IStudentAttemptsFilter,
  StudentAttemptsFilter,
  toStudentAttemptsFilters
} from 'pages/evaluations/components/student-attempts-filter';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowAssignmentsTable } from './components/show-table';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const AssignmentShow = () => {
  const { queryResult } = useShow<IAssignment>();
  const { id } = useParams();

  const data = useMemo(() => queryResult.data?.data, [queryResult.data?.data]);

  const { tableProps, searchFormProps } = useTable<
    IAssignmentUser[],
    HttpError,
    IStudentAttemptsFilter
  >({
    resource: `assignments/${id}/users`,

    onSearch: toStudentAttemptsFilters,

    errorNotification: () => {
      return {
        message: 'Não foi possível carregar a lista de alunos',
        description: 'Erro',
        type: 'error'
      };
    }
  });

  return (
    <ShowLayout title="Visualizar atividade">
      <PageHeader
        title={data?.name}
        icon={FileDoneOutlined}
        meta={
          <Flex>
            <Tag>{data?.parent_type === 'Course' ? 'Curso' : 'Disciplina'}</Tag>
            <Tag>{data?.parent.name}</Tag>
          </Flex>
        }
        actions={<EditButton type="primary" />}
      />

      <Card>
        <StudentAttemptsFilter searchFormProps={searchFormProps} />

        {data?.id && (
          <ShowAssignmentsTable
            tableProps={tableProps}
            assignmentId={data.id}
          />
        )}
      </Card>
    </ShowLayout>
  );
};
